<div class="pageheader">
    <div class="page-title">
        <h1>Active retries</h1>
        <div class="btn-group">
            <button class="btn btn-link" (click)="refresh()">Refresh <ep-svg-icon icon="repeat"></ep-svg-icon></button>
        </div>
    </div>
</div>

<div class="xcontainer xcontainer-fixed">
    <div class="xrow">
        <div class="col-sm-12">
            <dx-data-grid biz-grid
                          [selection]='{ mode: "none" }'
                          [dataSource]='activeRetries'
                          [bizHideSelectedRowsComponent]="true"
                          [showResetButton]="true"
                          [showRefreshButton]="true"
                          (onRefresh)="refresh()">

                <dxo-editing mode="popup"
                             [allowAdding]="false"
                             [allowUpdating]="false"
                             [allowDeleting]="false">
                </dxo-editing>
                <dxo-summary>
                    <dxi-total-item column="RetryDateTime" summaryType="count"> </dxi-total-item>
                </dxo-summary>

                <dxi-column dataField="RetryDateTime" caption="Retry Release Time" dataType="datetime" sortOrder="asc" [format]="dateTimeService.getDevExpressDateTimeWithMsFunction"></dxi-column>
                <dxi-column dataField="CreatedDateTime" caption="Created" dataType="datetime" [format]="dateTimeService.getDevExpressDateTimeWithMsFunction"></dxi-column>
                <dxi-column dataField="Area" caption="Area" dataType="string"></dxi-column>
                <dxi-column dataField="AreaId" caption="Area Id" dataType="string"></dxi-column>
                <dxi-column dataField="FileGuidDocument" caption="File" dataType="string" cellTemplate="fileTemplate"></dxi-column>
                <dxi-column dataField="FileGuidContextProperties" caption="Context Properties" dataType="string" cellTemplate="fileTemplateContextProperties"></dxi-column>

                <ng-container *dxTemplate="let cell of 'fileTemplate'">
                    <button class="btn btn-link np" [title]="cell.data.FileGuidDocument" (click)="downloadFile(cell.data.FileGuidDocument, 'RetryMessage')">Download</button>
                </ng-container>

                <ng-container *dxTemplate="let cell of 'fileTemplateContextProperties'">
                    <button class="btn btn-link np" [title]="cell.data.FileGuidContextProperties" (click)="downloadFile(cell.data.FileGuidContextProperties, 'RetryMessageContextProperties')">Download</button>
                </ng-container>
            </dx-data-grid>
        </div>
    </div>
</div>
